export default {"src":"https://cloudflare.edhrec.com/_next/static/media/managur.05e0367a.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};